import React from "react";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  Typography,
  Avatar,
  ThemeProvider,
} from "@mui/material";
import "../index.css";
import { IoConstruct } from "react-icons/io5";
import HomeIcon from "@mui/icons-material/Home";
import VerifiedIcon from "@mui/icons-material/Verified";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import TourIcon from "@mui/icons-material/Tour";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
// import { theme } from "./theme"; // Assuming you've exported the theme from another file
import theme from "../theme";
import logo from "../images/APS_LOGO.png";
import { useUser } from "../Contexts/UserContext";

function SideMenu({ open, onClose }) {
  const navigate = useNavigate();
  const { user } = useUser();
  const { ClientId, RoleId } = user;
  return (
    <ThemeProvider theme={theme}>
      <Drawer
        open={open}
        onClose={onClose}
        sx={{
          width: 240,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 240,
            bgcolor: "#fff", // Uses the background color defined in the theme
          },
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "center",
            color: "#fff",
          }}
          className="bg-theme"
        >
          {/* <Avatar src={logo} sx={{ width: 48, height: 48 }} /> */}
          {/* <h3
            style={{
              color: "#fff",
              fontSize: "22px",
              margin: 0,
            }}
          >
            APS GROUP
          </h3> */}
          <img src={logo} style={{ width: "100%" }} />
        </Toolbar>
        <Divider />
        <List>
          {ClientId !== "11542" ? (
            <>
              <ListItemButton
                onClick={() => navigate("/dashboard")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <SpaceDashboardIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Dashboard"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#aaaaaa",
                    // color: "#444b59",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/attendance")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "1px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <QrCodeScannerIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Attendance"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#444b59", // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              {/* <ListItemButton
                onClick={() => navigate("/profile")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
             
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <AccountCircleIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Profile"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton> */}
              <ListItemButton
                onClick={() => navigate("/max-facility")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <EditCalendarIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Facility"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#444b59", // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/material")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "1px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <QrCodeScannerIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Materials"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#444b59", // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/MaterialsPage")}
                // className="bg-theme"
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <IoConstruct size={22} sx={{ color: "black" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Material Status"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/RMPage")}
                // className="bg-theme"
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <IoConstruct size={22} sx={{ color: "black" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Repair & Maintenance"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/panic")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <ReportProblemIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Panic"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#444b59", // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/BranchOpenClose")}
                // className="bg-theme"
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <IoConstruct size={22} sx={{ color: "black" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Branch Status"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>

              {ClientId === "1008" && (
                <>
                  <ListItemButton
                    onClick={() => navigate("/erp-page")}
                    sx={{
                      margin: "10px 5px",
                      borderRadius: "10px",
                      border: "2px solid #eee",
                      color: "#000",
                      // backgroundColor: "#444b59",
                      // "&:hover": {
                      //   backgroundColor: "#D10101",
                      //   opacity: 0.85,
                      //   color: "#fff",
                      // },
                      "&:hover": {
                        backgroundColor: "#D10101",
                        opacity: 0.85,
                        color: "#fff",
                        "& .MuiSvgIcon-root": {
                          color: "#fff",
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <EditCalendarIcon sx={{ color: "#000" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="ERP"
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: "0",
                        lineHeight: "1px",
                        margin: "0px 0px 0px 0vw",
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        // color: "#444b59", // color: "#aaaaaa",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    />
                  </ListItemButton>
                  <ListItemButton
                    onClick={() => navigate("/reports-summary")}
                    sx={{
                      margin: "10px 5px",
                      borderRadius: "10px",
                      border: "2px solid #eee",
                      color: "#000",
                      // backgroundColor: "#444b59",
                      // "&:hover": {
                      //   backgroundColor: "#D10101",
                      //   opacity: 0.85,
                      //   color: "#fff",
                      // },
                      "&:hover": {
                        backgroundColor: "#D10101",
                        opacity: 0.85,
                        color: "#fff",
                        "& .MuiSvgIcon-root": {
                          color: "#fff",
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <EditCalendarIcon sx={{ color: "#000" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="GET SUMMERY"
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: "0",
                        lineHeight: "1px",
                        margin: "0px 0px 0px 0vw",
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        // color: "#444b59", // color: "#aaaaaa",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    />
                  </ListItemButton>
                </>
              )}
            </>
          ) : (
            <>
              <ListItemButton
                onClick={() => navigate("/dashboard")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <SpaceDashboardIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Dashboard"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#aaaaaa",
                    // color: "#444b59",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/profile")}
                // className="bg-theme"
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <AccountCircleIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Profile"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/facility-report")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <AssignmentIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Facility Reports"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#444b59", // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/verification")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "2px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <VerifiedIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Verification"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#444b59", // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => navigate("/material")}
                sx={{
                  margin: "10px 5px",
                  borderRadius: "10px",
                  border: "1px solid #eee",
                  color: "#000",
                  // backgroundColor: "#444b59",
                  // "&:hover": {
                  //   backgroundColor: "#D10101",
                  //   opacity: 0.85,
                  //   color: "#fff",
                  // },
                  "&:hover": {
                    backgroundColor: "#D10101",
                    opacity: 0.85,
                    color: "#fff",
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <QrCodeScannerIcon sx={{ color: "#000" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Materials"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "1px",
                    margin: "0px 0px 0px 0vw",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    // color: "#444b59", // color: "#aaaaaa",
                    fontFamily: "Poppins, sans-serif",
                  }}
                />
              </ListItemButton>
            </>
          )}

          {RoleId != 4 && (
            <ListItemButton
              onClick={() => navigate("/events")}
              sx={{
                margin: "10px 5px",
                borderRadius: "10px",
                border: "2px solid #eee",
                color: "#000",
                // backgroundColor: "#444b59",
                // "&:hover": {
                //   backgroundColor: "#D10101",
                //   opacity: 0.85,
                //   color: "#fff",
                // },
                "&:hover": {
                  backgroundColor: "#D10101",
                  opacity: 0.85,
                  color: "#fff",
                  "& .MuiSvgIcon-root": {
                    color: "#fff",
                  },
                },
              }}
            >
              <ListItemIcon>
                <EditCalendarIcon sx={{ color: "#000" }} />
              </ListItemIcon>
              <ListItemText
                primary="Events"
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  padding: "0",
                  lineHeight: "1px",
                  margin: "0px 0px 0px 0vw",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  // color: "#444b59", // color: "#aaaaaa",
                  fontFamily: "Poppins, sans-serif",
                }}
              />
            </ListItemButton>
          )}
          {(ClientId === "11613" || ClientId === "11621") && (
            <>
              {/* {ClientId == "11613" && (
                <>
                  <ListItemButton
                    onClick={() => navigate("/BranchOpenClose")}
                    // className="bg-theme"
                    sx={{
                      margin: "10px 5px",
                      borderRadius: "10px",
                      border: "2px solid #eee",
                      color: "#000",
                      // backgroundColor: "#444b59",
                      // "&:hover": {
                      //   backgroundColor: "#D10101",
                      //   opacity: 0.85,
                      //   color: "#fff",
                      // },
                      "&:hover": {
                        backgroundColor: "#D10101",
                        opacity: 0.85,
                        color: "#fff",
                        "& .MuiSvgIcon-root": {
                          color: "#fff",
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <IoConstruct size={22} sx={{ color: "black" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Branch Status"
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: "0",
                        lineHeight: "1px",
                        margin: "0px 0px 0px 0vw",
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        // color: "#aaaaaa",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    />
                  </ListItemButton>
                </>
              )} */}
              {/* {RoleId != 4 && ( */}

              {/* )} */}
              {(ClientId == "11621" ||
                ClientId == "22045" ||
                ClientId == "11613") && (
                <>
                  {RoleId != 4 && (
                    <ListItemButton
                      onClick={() => navigate("/facility-report-type2")}
                      // className="bg-theme"
                      sx={{
                        margin: "10px 5px",
                        borderRadius: "10px",
                        border: "2px solid #eee",
                        color: "#000",
                        // backgroundColor: "#444b59",
                        // "&:hover": {
                        //   backgroundColor: "#D10101",
                        //   opacity: 0.85,
                        //   color: "#fff",
                        // },
                        "&:hover": {
                          backgroundColor: "#D10101",
                          opacity: 0.85,
                          color: "#fff",
                          "& .MuiSvgIcon-root": {
                            color: "#fff",
                          },
                        },
                      }}
                    >
                      <ListItemIcon>
                        <IoConstruct size={22} sx={{ color: "black" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary="SUBMIT PDF REPORTS"
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          padding: "0",
                          lineHeight: "1px",
                          margin: "0px 0px 0px 0vw",
                          letterSpacing: "2px",
                          textTransform: "uppercase",
                          // color: "#aaaaaa",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      />
                    </ListItemButton>
                  )}
                  <ListItemButton
                    onClick={() => navigate("/FieldOfficerVisit")}
                    // className="bg-theme"
                    sx={{
                      margin: "10px 5px",
                      borderRadius: "10px",
                      border: "2px solid #eee",
                      color: "#000",
                      // backgroundColor: "#444b59",
                      // "&:hover": {
                      //   backgroundColor: "#D10101",
                      //   opacity: 0.85,
                      //   color: "#fff",
                      // },
                      "&:hover": {
                        backgroundColor: "#D10101",
                        opacity: 0.85,
                        color: "#fff",
                        "& .MuiSvgIcon-root": {
                          color: "#fff",
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <IoConstruct size={22} sx={{ color: "black" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="View PDF REPORTS"
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: "0",
                        lineHeight: "1px",
                        margin: "0px 0px 0px 0vw",
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        // color: "#aaaaaa",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    />
                  </ListItemButton>
                </>
              )}

              {RoleId != 4 && (
                <>
                  <ListItemButton
                    onClick={() => navigate("/facility-report-submission")}
                    // className="bg-theme"
                    sx={{
                      margin: "10px 5px",
                      borderRadius: "10px",
                      border: "2px solid #eee",
                      color: "#000",
                      // backgroundColor: "#444b59",
                      // "&:hover": {
                      //   backgroundColor: "#D10101",
                      //   opacity: 0.85,
                      //   color: "#fff",
                      // },
                      "&:hover": {
                        backgroundColor: "#D10101",
                        opacity: 0.85,
                        color: "#fff",
                        "& .MuiSvgIcon-root": {
                          color: "#fff",
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <IoConstruct size={22} sx={{ color: "black" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Report Submission"
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: "0",
                        lineHeight: "1px",
                        margin: "0px 0px 0px 0vw",
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        // color: "#aaaaaa",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    />
                  </ListItemButton>
                </>
              )}
            </>
          )}
        </List>
      </Drawer>
    </ThemeProvider>
  );
}

export default SideMenu;
